// import React from 'react';
import icon_doc_1 from '../images/icon_doc_1.png';
// import docPdf from './documents/documentsApplications/test_pdf.pdf';
import docODistObuchenie from './documents/documentsEducation/polozhenie_o_distancionom_obuchenii.pdf';

import docUnstrukciaDOT from './documents/documentsDistEducation/instrukcia_po_DOT.docx';
// import doc from './documents/documentsMKU/test_pdf.pdf';
// import doc from './documents/documentsMKU/test_pdf.pdf';
// import doc from './documents/documentsMKU/test_pdf.pdf';
// import doc from './documents/documentsMKU/test_pdf.pdf';

const documentsListDistEducation = [
  {
    titleDoc: 'Положение о применении электронного обучения и дистанционных образовательных технологий на Курсах ГО',
    typeDoc: icon_doc_1,
    path: docODistObuchenie,
    docId: 1,
  },
  {
    titleDoc: 'Инструкция по прохождению обучения в заочной форме на Курсах ГО',
    typeDoc: icon_doc_1,
    path: docUnstrukciaDOT,
    docId: 2,
  },
];

export default documentsListDistEducation;
